module.exports = __webpack_public_path__ + "img/video-30.57b38ca6.png";